import { useCallback, useMemo } from "react"

import {
  RadioGroup,
  Radio,
  FormControlLabel,
  useTheme,
  styled,
} from "@mui/material"

import { useTranslation } from "providers/i18n"
import { useVenue } from "providers/venue"
import { getFeatureDetail } from "utils/feature"

const Image = styled("img")(() => ({}))
export const FilterVenueRadioButtons = (props) => {
  const { value = "", onChange } = props
  const { t } = useTranslation()
  const { venues = [], isMultiVenueProject } = useVenue()
  const venueInfos = useMemo(() => {
    return venues.map(getFeatureDetail)
  }, [venues])

  const theme = useTheme()
  const styleOverrides =
    theme.components[`VuiFilterVenueRadioButtons`]?.styleOverrides || {}
  const { root, labelImage } = styleOverrides

  const handleCheck = useCallback(
    (event) => {
      onChange(event.target.value)
    },
    [onChange]
  )

  return (
    isMultiVenueProject && (
      <RadioGroup row value={value} onChange={handleCheck} sx={root}>
        {venueInfos.map(({ id, name, logo }) => {
          return (
            <FormControlLabel
              key={`filter-${id}`}
              label={logo ? <Image src={logo} sx={labelImage} /> : t(name)}
              control={<Radio color="primary" />}
              value={id}
            />
          )
        })}
        <FormControlLabel
          control={<Radio color="primary" />}
          label={t("All Mall")}
          value=""
        />
      </RadioGroup>
    )
  )
}
